const INDEX_3DES = '02';
const KEY_3DES = '29028A7698EF4C6D3D252F02F4F79D5815389DF18525D326'; // 3des 秘钥
const IV_3DES = '70706C6976656F6B'; // 3des 偏移量
// eslint-disable-next-line max-len
const PUBLIC_KEY_RSA = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC7ABgtkp5CT/n/Btxe08vwdxDLjwq/TRAqj15fGRxbblfQSL4NHkFoXsvjPxXnKTVlEPiwoFo6TaT07wBOLhaxJ4BbxWAj9/Unt6IKgPdktfJ87LuxPFr8O8ldBDnzBZGLoEsAQJckcyRz3+cELXNhTA4AE/FXdqsOfL68snzXgQIDAQAB'; // rsa 公钥
const MD5_KEY = '99bdc3a2972142708eef47ebff2fc65e'; // md5 key

export {
  INDEX_3DES,
  KEY_3DES,
  IV_3DES,
  PUBLIC_KEY_RSA,
  MD5_KEY,
};
